<form id="register-form" [formGroup]="formGroup" (ngSubmit)="createItem($event)" class="info-content-container">
  <div id="titleHeader" class="title-header flex-row">
    <span class="flex-1">{{ "report.admin.createNewItem" | translate }}</span>
    <button class="icon-button icon-close" type="button" (click)="goToReports()"></button>
  </div>
  <div class="scroll-container">
    <div class="content">
      <div class="information-container">
        <div class="statistics-title statistics-title--full">
          {{ "users.main.information" | translate }}
        </div>
        <div class="information-content">
          <div class="flex-row">
            <div class="flex-2 card-cell">
              <reporting-tool-template-picker placeholder="report.item.template" formControlName="template" [required]="true" />
            </div>
            <div class="flex-1 card-cell"></div>
          </div>
          <div class="flex-row">
            <div class="flex-1 card-cell">
              <sag-ui-input
                formControlName="dueDate"
                [type]="'date'"
                [required]="true"
                [label]="'report.item.dueDate' | translate"
                [placeholder]="'MM/DD/YYYY'" />
            </div>
            <div class="flex-1 card-cell">
              <sag-ui-input
                formControlName="reportStartDate"
                [type]="'date'"
                [required]="true"
                [label]="'report.item.reportStartDate' | translate"
                [placeholder]="'MM/DD/YYYY'" />
            </div>
            <div class="flex-1 card-cell">
              <sag-ui-input
                formControlName="reportEndDate"
                [type]="'date'"
                [required]="true"
                [label]="'report.item.reportEndDate' | translate"
                [placeholder]="'MM/DD/YYYY'" />
            </div>
          </div>
          <div class="flex-row">
            <div class="flex-1 card-cell">
              <reporting-tool-responsible-picker
                placeholder="report.admin.selectResponsible"
                formControlName="responsible"
                [required]="true"
                [multiple]="true" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
